module.exports = __webpack_public_path__ + "img/bank-account-setting.21ae2e50.svg";